import type { Rarity } from "@/domain/gems-game/domain/lib/Earning";
import { RARITY_GRADIENT_MAP } from "@/utils/rewards";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

interface RarityTextProps {
  rarity?: Rarity;
  sx?: SxProps<Theme>;
}

export const RarityText = ({ rarity, sx }: RarityTextProps) => {
  if (!rarity) {
    return;
  }
  return (
    <Box
      component="span"
      sx={{
        background: RARITY_GRADIENT_MAP[rarity],
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        display: "inline-block",
        ...sx,
      }}
    >
      {rarity}
    </Box>
  );
};

const startsWithVowel = (rarity: Rarity) => {
  return ["A", "E", "I", "O", "U"].includes(rarity.charAt(0));
};

export const RarityTextWithIndefiniteArticle = ({
  rarity,
  sx,
}: RarityTextProps) => {
  if (!rarity) {
    return;
  }

  return (
    <>
      {startsWithVowel(rarity) ? "an " : "a "}
      <RarityText rarity={rarity} sx={sx} />
    </>
  );
};
